class CartReservationTimer {
  constructor() {
    this.interval = null;
    this.expiry = 0;
    this.storageKey = 'famme_cart_timer_expiry';
  }

  init(minutes) {
    clearInterval(this.interval);
    const now = Date.now();
    let expiry = parseInt(localStorage.getItem(this.storageKey) || '0');
    if (!expiry || expiry <= now) {
      expiry = now + minutes * 60 * 1000;
      localStorage.setItem(this.storageKey, expiry.toString());
    }
    this.expiry = expiry;
    this._tick();
    this.interval = setInterval(() => this._tick(), 1000);
  }

  reset(minutes) {
    clearInterval(this.interval);
    this.expiry = Date.now() + minutes * 60 * 1000;
    localStorage.setItem(this.storageKey, this.expiry.toString());
    this._tick();
    this.interval = setInterval(() => this._tick(), 1000);
  }

  _tick() {
    const el = document.getElementById('CartTimer-Countdown');
    if (!el) { clearInterval(this.interval); return; }
    const remaining = Math.max(0, this.expiry - Date.now());
    const m = Math.floor(remaining / 60000);
    const s = Math.floor((remaining % 60000) / 1000);
    el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    if (remaining <= 0) clearInterval(this.interval);
  }
}

window.cartReservationTimer = new CartReservationTimer();

function refreshCartDrawer() {
  fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(r => r.json())
    .then(data => {
      const parser = new DOMParser();

      if (data['cart-drawer']) {
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newInner = doc.querySelector('.drawer__inner');
        const inner = document.querySelector('#CartDrawer .drawer__inner');
        if (inner && newInner) inner.innerHTML = newInner.innerHTML;

        const isEmpty = doc.querySelector('cart-drawer')?.classList.contains('is-empty') ?? false;
        const cartDrawerEl = document.querySelector('cart-drawer');
        const cartDrawerItemsEl = document.querySelector('cart-drawer-items');
        if (cartDrawerEl) cartDrawerEl.classList.toggle('is-empty', isEmpty);
        if (cartDrawerItemsEl) cartDrawerItemsEl.classList.toggle('is-empty', isEmpty);
      }

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data['cart-icon-bubble']) {
        const newBubble = parser.parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
      }
      initCartSocialProof();
    });
}

let giftSyncing = false;
async function syncGiftProduct() {
  if (giftSyncing) return;
  const bar = document.getElementById('CartRewardsBar');
  if (!bar || !bar.dataset.giftVariantId) return;

  const variantId = parseInt(bar.dataset.giftVariantId);
  const threshold = parseInt(bar.dataset.giftThreshold);
  if (!variantId || !threshold) return;

  giftSyncing = true;
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const giftItem = cart.items.find(i => i.variant_id === variantId && i.properties && i.properties._gift === 'true');
    const manualItem = cart.items.find(i => i.variant_id === variantId && (!i.properties || !i.properties._gift));
    const eligible = cart.total_price >= threshold;

    if (eligible && !giftItem) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _gift: 'true' } }] })
      });
      refreshCartDrawer();
    } else if (!eligible && giftItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 })
      });
      refreshCartDrawer();
    }
  } finally {
    giftSyncing = false;
  }
}

function initCartSocialProof() {
  const el = document.getElementById('CartSocialProof');
  if (!el) return;
  const countEl = document.getElementById('CartSocialProof-Count');
  if (!countEl) return;

  const state = el.dataset.state || 'shipping';
  const runKey = '__spRunning_' + state;
  const storageKey = 'sp_count_' + state;
  const stoppedKey = 'sp_stopped_' + state;

  const isGift = state === 'gift';
  const min = parseInt(isGift ? el.dataset.giftMin : el.dataset.min) || (isGift ? 10 : 50);
  const max = parseInt(isGift ? el.dataset.giftMax : el.dataset.max) || (isGift ? 80 : 300);

  // Timer already running for this state — just repopulate the (possibly re-rendered) element
  if (window[runKey]) {
    const saved = sessionStorage.getItem(storageKey);
    if (saved) countEl.textContent = '+' + saved;
    return;
  }
  window[runKey] = true;

  // Stopped this session — freeze at saved value
  if (sessionStorage.getItem(stoppedKey)) {
    countEl.textContent = '+' + sessionStorage.getItem(storageKey);
    return;
  }

  // Start from min (or resume from saved if page reloaded mid-session)
  let current = parseInt(sessionStorage.getItem(storageKey)) || min;
  countEl.textContent = '+' + current;
  sessionStorage.setItem(storageKey, current);

  function tick() {
    if (sessionStorage.getItem(stoppedKey)) return;

    const remaining = max - current;
    const stopThreshold = Math.ceil((max - min) * 0.05);

    if (remaining <= stopThreshold) {
      sessionStorage.setItem(stoppedKey, '1');
      return;
    }

    // Increment 1–15% of remaining gap randomly
    const increment = Math.max(1, Math.floor(Math.random() * remaining * 0.15));
    current = Math.min(current + increment, max);
    sessionStorage.setItem(storageKey, current);

    const live = document.getElementById('CartSocialProof-Count');
    if (live) live.textContent = '+' + current;

    setTimeout(tick, 2 * 60 * 1000);
  }

  setTimeout(tick, 2 * 60 * 1000);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.onclick=e=>{
      if (e.target.classList.contains('slider-button--next')){
        e.target.closest('cart-drawer-items').lastElementChild.scrollLeft += e.target.closest('cart-drawer-items').lastElementChild.getBoundingClientRect().width;
      } else if (e.target.classList.contains('slider-button--prev')){
        e.target.closest('cart-drawer-items').lastElementChild.scrollLeft -= e.target.closest('cart-drawer-items').lastElementChild.getBoundingClientRect().width;
      }
    }
    this.onchange=e=>{
      if (e.target.type == 'radio'){
        if (e.target.src && e.target.src != ''){
          e.target.closest('.card-wrapper').querySelector('img.motion-reduce').src = e.target.src;
          e.target.closest('.card-wrapper').querySelector('img.motion-reduce').removeAttribute('srcset');
        }
        if (e.target.closest('variant-selects').children.length > 3){
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"][opt3="'+e.target.closest('.card-wrapper').querySelector('.opt3 input:checked').value+'"]') && 
             !e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"][opt3="'+e.target.closest('.card-wrapper').querySelector('.opt3 input:checked').value+'"]').disabled){
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
          }
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"][opt3="'+e.target.closest('.card-wrapper').querySelector('.opt3 input:checked').value+'"]')){
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"][opt3="'+e.target.closest('.card-wrapper').querySelector('.opt3 input:checked').value+'"]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              const pdp = new DOMParser().parseFromString(html, 'text/html');
              if (pdp.querySelector('section.product__info-container button.product-form__submit').disabled){
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
              } else {
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
              }
              e.target.closest('variant-selects').innerHTML = pdp.querySelector('.product__info-container>variant-selects').innerHTML;
            });
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select option[selected]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select option[selected]').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              e.target.closest('variant-selects').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product__info-container>variant-selects').innerHTML;
            });
          }
        } else if (e.target.closest('variant-selects').children.length > 2){
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"]') && 
             !e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"]').disabled){
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
          }
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"]')){
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"][opt2="'+e.target.closest('.card-wrapper').querySelector('.opt2 input:checked').value+'"]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              const pdp = new DOMParser().parseFromString(html, 'text/html');
              if (pdp.querySelector('section.product__info-container button.product-form__submit').disabled){
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
              } else {
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
              }
              e.target.closest('variant-selects').innerHTML = pdp.querySelector('.product__info-container>variant-selects').innerHTML;
            });
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select option[selected]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select option[selected]').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              e.target.closest('variant-selects').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product__info-container>variant-selects').innerHTML;
            });
          }
        } else {
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"]') && 
             !e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"]').disabled){
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
          }
          if (e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"]')){
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select>option[opt1="'+e.target.closest('.card-wrapper').querySelector('.opt1 input:checked').value+'"]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              var pdp = new DOMParser().parseFromString(html, 'text/html');
              if (pdp.querySelector('section.product__info-container button.product-form__submit').disabled){
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = true;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('sold');
              } else {
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
                e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
              }
              e.target.closest('variant-selects').innerHTML = pdp.querySelector('.product__info-container>variant-selects').innerHTML;
            });
          } else {
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit').disabled = false;
            e.target.closest('.card-wrapper').querySelector('button.product-form__submit>span').innerText = e.target.closest('.card-wrapper').querySelector('button.product-form__submit').getAttribute('add');
            e.target.closest('.card-wrapper').querySelector('select').value = e.target.closest('.card-wrapper').querySelector('select option[selected]').value;
            fetch(e.target.closest('variant-selects').getAttribute('href') + e.target.closest('.card-wrapper').querySelector('select option[selected]').value, {method: 'GET', credentials: 'include'}).then(response=>response.text()).then(html=>{
              e.target.closest('variant-selects').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product__info-container>variant-selects').innerHTML;
            });
          }
        }
        if (e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('comprice') != '' &&
           e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('comprice') != e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('price')){
          e.target.closest('.card-wrapper').querySelector('s.price-item').innerText = e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('comprice');
          e.target.closest('.card-wrapper').querySelector('span.price-item--sale').innerText = e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('price');
          e.target.closest('.card-wrapper').querySelector('div.price').classList.add('price--on-sale');
        } else {
          e.target.closest('.card-wrapper').querySelector('span.price-item--regular').innerText = e.target.closest('.card-wrapper').querySelector('select').options[e.target.closest('.card-wrapper').querySelector('select').selectedIndex].getAttribute('price');
          e.target.closest('.card-wrapper').querySelector('div.price').classList.remove('price--on-sale');
        }
      }
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004130690"
      }
    });
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    const timerBanner = this.querySelector('#CartDrawer-Timer');
    if (timerBanner) {
      window.cartReservationTimer.init(parseInt(timerBanner.dataset.minutes) || 10);
    }
    initCartSocialProof();
    syncGiftProduct();
    syncDiscountFromCart();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      const timerBanner = this.querySelector('#CartDrawer-Timer');
      if (timerBanner) {
        window.cartReservationTimer.reset(parseInt(timerBanner.dataset.minutes) || 10);
      }
      syncGiftProduct();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
  initCartSocialProof();
  syncGiftProduct();
});

async function syncDiscountFromCart() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const codes = cart.discount_codes;
    if (codes && codes.length > 0) {
      const code = codes[0].code;
      try { sessionStorage.setItem('drawer_discount_code', code); } catch(e) {}
      const label = document.getElementById('drawer-discount-code-label');
      const tag = document.getElementById('drawer-discount-tag');
      if (tag && label) { label.textContent = code; tag.style.display = 'inline-flex'; }
    }
  } catch(e) {}
}

window.addEventListener('pageshow', async function (event) {
  if (event.persisted) {
    await syncDiscountFromCart();
    refreshCartDrawer();
  }
});

